import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { NavigationProvider } from './context/NavigationContext';
import { RepaymentProvider } from './context/RepaymentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <NavigationProvider>
        <RepaymentProvider>
          <App />
        </RepaymentProvider>
      </NavigationProvider>
    </React.StrictMode>
  </BrowserRouter>
);